export const languages = [
    { value: 'en', label: 'English' },
    { value: 'ro', label: 'Română' },
    { value: 'ru', label: 'Русский' }
];
